import { NumberCell } from '@/creditflowresearch/ui/common/components/DataCells';

interface ITenorCellProps {
  tenor: number | null,
  perpetual: boolean | null,
}

const TenorCell = ({ tenor, perpetual }: ITenorCellProps) => {
  if (tenor !== null && tenor !== undefined) {
    return (<NumberCell value={ tenor } decimals={ 2 } />);
  }

  if (perpetual) {
    return (<>Perp</>);
  }

  return (<>-</>);
};

export default TenorCell;
